module.exports = __webpack_public_path__ + "static/offer-brand-basic-7-2d71d0cbb132827519d7f2638ec20aa3.jpg";